import React from 'react';
import { Card, Dropdown } from 'react-bootstrap';
import UserIcon from 'assets/img/post/user-bg.png';
import Avatar from 'components/base/Avatar';
import Button from 'components/base/Button';
import { Props, Status } from './jobPost.type';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookmark } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import { formatNumber } from 'helpers/number-utils';
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';

function JobPostCard({
  status,
  onSave,
  isBookmarked,
  data,
  renderDiscriptionPattern,
  onDelete,
  onEdit,
  onView,
  isCanRemove,
  onMarkAsClosed,
  onReopen,
  onActive
}: Props) {
  const isReadOnly = typeof onSave === 'function';
  const actionMapping: Record<Status, React.ReactNode> = {
    Active: (
      <Button
        variant="outline-danger"
        onClick={() => {
          if (onMarkAsClosed && data) onMarkAsClosed(data);
        }}
      >
        Mark as Closed
      </Button>
    ),
    Closed: (
      <Button
        variant="outline-primary"
        onClick={() => {
          if (onReopen && data) onReopen(data);
        }}
      >
        Reopen
      </Button>
    ),
    Expired: (
      <Button
        variant="primary"
        onClick={() => {
          if (onActive && data) onActive(data);
        }}
      >
        Active
      </Button>
    )
  };
  return (
    <Card>
      <Card.Body>
        <header className="d-flex justify-content-between mb-2">
          <div className="d-flex gap-3 align-items-center">
            <Avatar src={UserIcon} size="xl" rounded="soft" />
            <div>
              <h5>{data?.title}</h5>
              <p className="m-0">{data?.jobLocation}</p>
            </div>
          </div>
          {isReadOnly ? (
            <FontAwesomeIcon
              icon={faBookmark}
              className={classNames('form-icon', {
                'text-body': !isBookmarked,
                'text-primary': isBookmarked
              })}
            />
          ) : (
            (onView || onEdit || onDelete) && (
              <RevealDropdownTrigger>
                <RevealDropdown>
                  {typeof onView === 'function' && data && (
                    <Dropdown.Item eventKey="view" onClick={() => onView(data)}>
                      View
                    </Dropdown.Item>
                  )}
                  {typeof onEdit === 'function' && data && (
                    <Dropdown.Item eventKey="edit" onClick={() => onEdit(data)}>
                      Edit
                    </Dropdown.Item>
                  )}
                  {typeof onDelete === 'function' && data && (
                    <>
                      <Dropdown.Divider />
                      <Dropdown.Item
                        eventKey="remove"
                        onClick={() => onDelete(data)}
                        disabled={!isCanRemove}
                        className={isCanRemove ? 'text-danger' : ''}
                      >
                        Remove
                      </Dropdown.Item>
                    </>
                  )}
                </RevealDropdown>
              </RevealDropdownTrigger>
            )
          )}
        </header>
        {typeof renderDiscriptionPattern === 'function' && data && (
          <p>{renderDiscriptionPattern(data)}</p>
        )}

        <footer className="d-flex justify-content-between align-items-center">
          <div>
            <span className="text-lg">
              Rs:{formatNumber(data?.salaryRange[0] || 0)} -{' '}
              {formatNumber(data?.salaryRange[1] || 0)}
            </span>{' '}
            / Month
          </div>
          {actionMapping[status]}
        </footer>
      </Card.Body>
    </Card>
  );
}

export default JobPostCard;
